export { SearchHighlightPipeModule } from './search-highlight.pipe.module';
export { SearchHighlightPipe } from './search-highlight.pipe';
